<template>
	<div id="clubClass_org_index">
		<dv-full-screen-container class="bg">
			<dv-loading v-if="loading">Loading...</dv-loading>
			<div v-else class="host-body">
				<dialog-table v-if="Visible" ref="dialog" @closeWin="closeWin"></dialog-table>
				<div v-on:click="screen()"><dv-decoration-9 :color="['#55ffff', '#0090ff']" class="full_screen">{{ screenName }}</dv-decoration-9></div>
				<!-- 第一行标题装饰条 -->
				<div class="d-flex jc-center title_bg">
					<div class="title">
						<span class="title-text">{{ schoolName }}</span>
					</div>
				</div>
				<div class="body-box">
					<!-- 数据开始 -->
					<div class="w-100 content-box">
						<div class="main_grid">
							<!-- 第一列 -->
							<div style="height: 92vh;">
								<div class="l_block">
									<dv-border-box-10 :color="['#244b8a', '#83d0ff']">
										<left1 />
									</dv-border-box-10>
								</div>
								<div class="l_block">
									<dv-border-box-10 :color="['#244b8a', '#83d0ff']">
										<left2 />
									</dv-border-box-10>
								</div>
								<div class="l_block">
									<dv-border-box-10 :color="['#244b8a', '#83d0ff']">
										<left3 />
									</dv-border-box-10>
								</div>
							</div>
							<!-- 第二列 -->
							<div style="height: 92vh;">
								<!-- 上半部分 -->
								<div class="mt_block">
									<div class="top_block">
										<div class="float-l icon">
											<img class="block_circle" src="../../assets/img/block_circle.gif">
											<img class="jianbian_icon" src="../../assets/img/jianbian_icon.png">
											<img class="tea_icon" src="../../assets/img/tea_icon.png">
										</div>
										<div class=" float-l">
											<div class="block_tnum"><b class="colorbluegreen">{{ teaNum }}</b></div>
											<div class="title-item">教师人数</div>
										</div>
									</div>
									<div class="top_block">
										<div class="float-l icon">
											<img class="block_circle" src="../../assets/img/block_circle.gif">
											<img class="jianbian_icon" src="../../assets/img/jianbian_icon.png">
											<img class="tea_icon" src="../../assets/img/book_icon.png">
										</div>
										<div class="block_tnum"><b class="colorbluegreen">{{ courseNum }}</b></div>
										<div class="title-item">课程总数</div>
									</div>
									<div class="top_block">
										<div class="float-l icon">
											<img class="block_circle" src="../../assets/img/block_circle.gif">
											<img class="jianbian_icon" src="../../assets/img/jianbian_icon.png">
											<img class="tea_icon" src="../../assets/img/stu_icon.png">
										</div>
										<div class="float-l">
											<div class="block_tnum"><b class="colorbluegreen">{{ stuNum }}</b></div>
											<div class="title-item">学生人数</div>
										</div>
									</div>
								</div>
								<!-- 上半部分结束 -->
								<!-- 相册开始 -->
								<div class="index_photo">
									<center />
								</div>
								<!-- 相册结束 -->
								<!-- 下半部分 -->
								<div class="mb_block">
									<dv-border-box-1 :color="['#244b8a', '#62c3ff']">
										<center1 />
									</dv-border-box-1>
								</div>
								<!-- 下半部分结束 -->
							</div>
							<!-- 第二列结束 -->
							<!-- 第三列开始 -->
							<div style="height: 92vh;">
								<!-- 1 -->
								<div class="r_block">
									<dv-border-box-10 :color="['#244b8a', '#69b9ff']">
										<right1 @showBigEven="showBigEven" />
									</dv-border-box-10>
								</div>
								<!-- 2 -->
								<div class="r_block">
									<dv-border-box-10 :color="['#244b8a', '#69b9ff']">
										<right2 />
									</dv-border-box-10>
								</div>
							</div>
							<!-- 第三列结束 -->
						</div>
					</div>
					<!-- 第四行数据结束 -->
				</div>
			</div>
		</dv-full-screen-container>
	</div>
</template>

<script>
var storage = window.localStorage;
var orgId = storage.getItem("orgId");
var schoolName = storage.getItem("schoolName");
var orgCode = storage.getItem("orgCode");
var source = storage.getItem("source");
import left1 from "./left1";
import left2 from "./left2";
import left3 from "./left3";
import right1 from "./right1";
import right2 from "./right2";
import center from "./center";
import center1 from "./center1";
import dialogTable from "./dialogTable";

export default {
	data() {
		return {
			loading: true,
			schoolName: schoolName,
			teaNum: 0,
			courseNum: 0,
			stuNum: 0,
			fullscreen: false,
			screenName: "全屏",
			Visible: false
		};
	},
	components: {
		dialogTable,
		left1,
		left2,
		left3,
		right1,
		right2,
		center,
		center1
	},
	mounted() {
		this.cancelLoading();
		this.initData();
		// 定时刷新时间
		let _this = this;
		// 定时器刷新，30分钟
		this.interval = setInterval(() => {
			_this.initData();
		}, 1000 * 60 * 30);
	},
	methods: {
		showBigEven(data) {
			console.log("父页面:" + data);
			// data为子页面的传过来的数据
			this.Visible = true;
		},
		closeWin() {
			this.Visible = false;
		},
		//关闭loading加载条
		cancelLoading() {
			setTimeout(() => {
				this.loading = false;
			}, 1000);
		},
		initData() {
			let _this = this;
			//判断访问客户端类型
			if (source == 'window') {
				_this.screenName = "全屏";
			} else {
				_this.screenName = "返回";
			}
			this.$http.get("/dataView/clubClass/getIndexInfo?orgId=" + orgId).then(res => {
				if (res.data.code === 200) {
					var result = res.data.result;
					_this.teaNum = result.teaNum;
					_this.stuNum = result.stuNum;
					_this.courseNum = result.courseNum;
				}
			});
		},
		//点击全屏
		screen: function () {
			//判断访问客户端类型
			if (source == 'window') {
				let _this = this;
				let element = document.documentElement;
				if (_this.fullscreen) {
					if (document.exitFullscreen) {
						document.exitFullscreen();
					} else if (document.webkitCancelFullScreen) {
						document.webkitCancelFullScreen();
					} else if (document.mozCancelFullScreen) {
						document.mozCancelFullScreen();
					} else if (document.msExitFullscreen) {
						document.msExitFullscreen();
					}
					_this.screenName = "全屏";
				} else {
					if (element.requestFullscreen) {
						element.requestFullscreen();
					} else if (element.webkitRequestFullScreen) {
						element.webkitRequestFullScreen();
					} else if (element.mozRequestFullScreen) {
						element.mozRequestFullScreen();
					} else if (element.msRequestFullscreen) {
						element.msRequestFullscreen();
					}
					_this.screenName = "取消";
				}
				_this.fullscreen = !_this.fullscreen;
			} else {
				//window.AndroidWebView.finish();
				this.$router.replace('/dataView/appIndex/school?orgCode=' + orgCode);
			}
		}
	},
	beforeDestroy() {
		clearInterval(this.interval);
	}
};
</script>

<style lang="scss">
@import "../../assets/scss/clubClassIndex.scss";

#clubClass_org_index {

	.title_bg {
		width: 100%;
		height: 7vh;
		background: url("../../assets/img/afterclass_titbg.png") center no-repeat;
	}

	.index_photo {
		height: 48vh;
		margin: 0 0.2rem;
	}

	.title {
		width: 100%;
		text-align: left;

		.title-text {
			display: inline-block;
			font-size: 0.25rem !important;
			font-weight: bold;
			line-height: 0.25rem;
			margin-left: 2.3rem;
			margin-top: 0.2rem;
			background-image: linear-gradient(135deg, #55ffff, #54c3ff);
			-webkit-background-clip: text;
			color: transparent;
		}
	}

	.mt_block {
		height: 15vh;
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
		margin: 0 1.5rem;
		font-size: 0.19rem;
		padding-top: 0.65rem;
		color: #42c3ff;
		overflow: hidden;
	}

	.mt_block .icon {
		margin-right: 0.3rem;
		margin-top: 0.18rem;
		// 新增
		position: relative;
		height: 70px;
		width: 70px;
		perspective: 180px;
	}

	.mt_block .block_circle {
		// 新增
		position: absolute;
		transform: rotateX(70deg);
	}

	.mt_block img.block_circle {
		width: 100%;
	}

	.mt_block .jianbian_icon {
		// 新增
		position: absolute;
		bottom: 0.18rem;
		left: -0.15rem
	}

	.mt_block .tea_icon {
		// 新增
		position: absolute;
		bottom: 0.6rem;
		left: 0.28rem
	}

	.mt_block img.tea_icon {
		width: 0.4rem;
	}

	.block_tnum {
		font-size: 0.25rem;
	}

	.block_tnum b {
		font-size: 0.4rem;
	}

	.l_block {
		margin: 0.22rem 0;
		height: 29vh;
	}

	.r_block {
		margin: 0.2rem 0;
		height: 44.5vh;
	}

	.mb_block {
		height: 29vh;
		padding: 0 0.2rem;
	}

	.top_block {
		width: 2.2rem;
		margin-left: 0.6rem;
	}
}
</style>